export function getMuciifiOrigin() {
  const url = new URL(window.location.origin);

  const host = url.hostname;

  if (host.endsWith(".muciifi.com")) {
    url.hostname = "muciifi.com";
  } else if (host.endsWith(".muciifidev.com")) {
    url.hostname = "muciifidev.com";
  }

  return url.origin;
}

export function getResolvedURLGivenSubdomain(sd:string){
  const url = new URL(getMuciifiOrigin());

    url.hostname = `${sd}.${url.hostname}`;

    return url.toString();
}